
export const firebaseAuthenticationAPIErrors = {
  "Firebase: Error (auth/email-already-in-use).":
    "The provided email is already in use by an existing user!",
  "Firebase: Error (auth/email-already-exists).":
    "The provided email is already in use by an existing user!",
  "Firebase: Error (auth/id-token-expired).":
    "The provided ID token is expired!",
  "Firebase: Error (auth/invalid-email).": "Invalid email",
  "Firebase: Error (auth/invalid-password).": "Invalid password!",
  "Firebase: Error (auth/invalid-credential).": "Invalid credential!",
  "Firebase: Error (auth/internal-error).": "Unexpected error!",
};